module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16KImER/tc-custom/9781423612186.jpg?1736860258876",
      "alt": "This image is the cover for the book 101 Things To Do With Ramen Noodles, 101 Things To Do With"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("101 Things To Do With Ramen Noodles, 101 Things To Do With\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Expand your ramen repertoire with these inventive recipes in the bestselling cookbook series!")]), _c('br'), _vm._v(" Ramen is fast, easy, and filling, but what can be done to spruce it up and give it a whole new life? In this collection, featured on the "), _c('i', [_vm._v("Today")]), _vm._v(" show and the Food Network, there are 101 answers to that question, with recipes for: "), _c('br'), _vm._v(" * Creamy Chicken Noodle Soup"), _c('br'), _vm._v(" * Summer Garden Soup "), _c('br'), _vm._v(" * Zucchini Salad"), _c('br'), _vm._v(" * Creamy Beef and Broccoli Noodles "), _c('br'), _vm._v(" * Ramen Burgers"), _c('br'), _vm._v(" * Chicken Alfredo"), _c('br'), _vm._v(" * Pork Chop Ramen"), _c('br'), _vm._v(" * Tuna Noodle Casserole"), _c('br'), _vm._v(" * Garlic Noodle Sauté"), _c('br'), _vm._v(" * Beer Noodles (the ultimate college crowd pleaser!)"), _c('br'), _vm._v(" * Chinese Veggie Noodles"), _c('br'), _vm._v(" * Corny Cheese Noodles, and many more\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Toni Patrick\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Toni Patrick is also the author of 101 Things to Do with Ramen Noodles, 101 Things to Do with Mac & Cheese, and 101 Things to Do with Canned Biscuits. She lives in Colorado.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0